export default {
  name: 'global',
  store() {
    return {
      init() {
      }
    }
  }
}
